export const isNotEmpty = (value: any) => !isEmpty(value);

export const isEmpty = (value: any) => {
  var typeofValue = typeof value;

  if (value === undefined || value === null) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeofValue == 'object' && Object.keys(value).length === 0) {
    return true;
  }

  if (typeofValue == 'number' && value == 0) {
    return true;
  }

  if (typeofValue == 'string') {
    value = value.replace(/\s/g, '');
    if (value === '') {
      return true;
    }
  }

  return false;
};

export const removeAllSpaces = (valor: string): string => {
  return valor.replace(/\s+/g, "");
}

export const toUpperCaseFirstChar = (value: string) => {
  return value.slice(0, 1).toUpperCase() + value.slice(1);
}